import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { ownerNav } from '@/lib/navConfig';
import SuppliersManager from '@/components/suppliers/SuppliersManager';

export default function OwnerSuppliers() {
  return (
    <AppShell nav={ownerNav} title="Supplier" showBell>
      <SuppliersManager />
    </AppShell>
  );
}
